import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import artistImageUrlGenerator from 'utils/artistImageUrlGenerator';

const classes = {
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  card: {},
};

function ArtistListItem({ artist }) {
  const imageUrl = artistImageUrlGenerator(artist.pageid, 320);

  return (
    <Grid item xs={6} md={3} key={artist.pageid}>
      <Card sx={classes.card} data-testid="artist-card">
        <CardActionArea component={Link} to={`/artist/${artist.pageid}`}>
          <CardMedia sx={classes.media} image={imageUrl} title={artist.name} />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h3">
              {artist.name}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
}

ArtistListItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default ArtistListItem;
